import core from './core';
import csc from './csc';
import psfa from './psfa';
import scs from './scs';

describe('submission confirmation email configuration', () => {
  it('enables confirmation emails for core and PSFA only', () => {
    expect(core.confirmationEmail).toBe(true);
    expect(psfa.confirmationEmail).toBe(true);
    expect(csc.confirmationEmail).toBeUndefined();
    expect(scs.confirmationEmail).toBeUndefined();
  });
});
